import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { NOT_STARTED, IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_DEALS } from '@/lib/constants/api'
import getDealModel from './models/deal'
import updateStatus from '@/store/helpers/updateStatus'
import { notifySuccess, notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'
import getDealSummary from './models/dealSummary'

const deal = {
  namespaced: true,
  state: {
    ...getDealModel(),
    dealSummary: {
      ...getDealSummary()
    }
  },
  getters: {
    getField,
    getDealObject: (state) => {
      return state
    }
  },
  mutations: {
    updateField,
    updateStatus,
    clearDeal: (state) => {
      state.id = null
      state.name = null
      state.notes = null
      state.statusId = null
      state.createdBy = null
      state.createdByName = null
      state.updateddBy = null
      state.updatedByName = null
      state.createdAt = null
      state.updatedAt = null
      state.dealClientId = null
      state.dealClientName = null
      state.dealCandidateId = null
      state.dealCandidateFirstName = null
      state.dealCandidateLastName = null
      state.dealAssignmentId = null
      state.dealAssignmentType = null
      state.dataMissingTasks = {
        clientDataMissing: false,
        candidateDataMissing: false,
        contractDetailsDataMissing: false
      }
      state.dealCreationTypeId = null
      state.dealSummary = {
        ...getDealSummary()
      }
      state.zrJobOpeningId = null
    },
    setDeal: (state, deal) => {
      state.id = deal.id
      state.name = deal.name
      state.notes = deal.notes
      state.statusId = deal.statusId
      state.createdBy = deal.createdBy
      state.createdByName = deal.createdByName
      state.updateddBy = deal.updateddBy
      state.updatedByName = deal.updatedByName
      state.createdAt = deal.createdAt
      state.updatedAt = deal.updatedAt
      state.dealClientId = deal.dealClientId
      state.dealClientName = deal.dealClientName
      state.dealCandidateId = deal.dealCandidateId
      state.dealCandidateFirstName = deal.dealCandidateFirstName
      state.dealCandidateLastName = deal.dealCandidateLastName
      state.dealAssignmentId = deal.dealAssignmentId
      state.dealAssignmentType = deal.dealAssignmentType
      state.createTask = deal.createTask
      state.dealCreationTypeId = deal.dealCreationTypeId
      state.zrJobOpeningId = deal.zrJobOpeningId
    }
  },
  actions: {
    save ({ state }) {
      return api.doPost({ path: PATH_DEALS, data: state })
    },
    update ({ state }) {
      return api.doPut({ path: PATH_DEALS, data: state })
    },
    getDeal: ({ commit, dispatch }, { id }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting deal, please wait...' })

      return api.doGet({ path: PATH_DEALS, parameters: { id } })
        .then(json => json.data)
        .then(deal => {
          commit('updateStatus', { status: COMPLETE })
          commit('setDeal', deal)
          hideProgressModal({ dispatch })

          return deal
        }).catch((error) => {
          hideProgressModal({ dispatch })
          commit('updateStatus', { status: ERROR, error })
        })
    },
    saveDeal: ({ state, commit, dispatch }, showDealSavedMessage = true) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving deal, please wait...' })

      const actionName = state.id ? 'update' : 'save'

      return dispatch(actionName).then(deal => {
        commit('updateStatus', { status: COMPLETE })

        if (!deal.data) {
          throw new Error('Unable to save deal. Check required fields.')
        }

        commit('clearDeal')
        hideProgressModal({ dispatch })
        if (showDealSavedMessage) {
          notifySuccess(dispatch, 'Deal saved')
        }
        commit('setDeal', deal.data)
        return deal
      }).catch((error) => {
        commit('updateStatus', { status: ERROR, error })
        hideProgressModal({ dispatch })
        notifyError(dispatch, 'Unable to save deal. Try again later')

        throw error
      })
    },
    deleteDeal ({ commit, dispatch }, id = null) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Deleting deal, please wait...' })
      return api.doDelete({
        path: PATH_DEALS,
        parameters: Object.assign({}, { id: id })
      })
        .then(response => {
          commit('updateStatus', { status: COMPLETE })

          if (!response.data) {
            throw new Error('Unable to delete deal')
          }

          commit('clearDeal')
          hideProgressModal({ dispatch })
          notifySuccess(dispatch, 'Deal deleted')
          return response.data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })
          notifyError(dispatch, 'Unable to delete deal')
        })
    },
    clearDeal: ({ commit }) => {
      commit('clearDeal')
      return commit('updateStatus', { status: NOT_STARTED })
    }
  }
}

export default deal
